module.exports = __webpack_public_path__ + "static/media/courier_open_door_tips.5132929.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/FreshCabinet/mp3/courier_open_door_tips.mp3
// module id = u0HL
// module chunks = 1